import { get as getConfig } from '@/helpers/config';

import { Select } from './Select';

interface Props {
    name: string;
    isClearable?: boolean;
    isDisabled?: boolean;
    placeholder?: string;
    className?: string;
}

/**
 * RHF analog of `Ui/Form/LocaleSelect.jsx`. Reads supported locales from
 * the app config and renders an RHF `<Select>`.
 */
export function LocaleSelect(props: Props) {
    const config = getConfig() as { language: { supported: string[] } };
    const options = config.language.supported.map((key) => {
        return { label: key, value: key };
    });

    return (
        <Select options={ options } { ...props } />
    );
}
